import { connect } from 'react-redux';
import _ from 'lodash';

import GDPR from './GDPR';

const mapState = state => ({
	countryCode: _.get(state, 'settings.country.code'),
	settings: _.get(state, 'settings'),
	translations: _.get(state, 'translations'),
});

const mapDispatch = () => ({});

export default connect(mapState, mapDispatch)(GDPR);
